import {
    ComposeFormType,
    QUICK_COMPOSE_FORM_TYPE,
} from 'owa-calendar-helpers-types/lib/ComposeTypes';
import {
    QuickComposeEntrySourceType,
    QUICK_COMPOSE_ENTRY_SOURCE_NEW_BUTTON,
    QUICK_COMPOSE_ENTRY_SOURCE_SURFACE,
    QUICK_COMPOSE_ENTRY_SOURCE_EDIT,
    QUICK_COMPOSE_ENTRY_SOURCE_UNDO_FROM_NEW_BUTTON,
    QUICK_COMPOSE_ENTRY_SOURCE_UNDO_FROM_SURFACE,
    QUICK_COMPOSE_ENTRY_SOURCE_UNDO_FROM_EDIT,
    QUICK_COMPOSE_ENTRY_SOURCE_PEEK_EDIT,
    QUICK_COMPOSE_ENTRY_SOURCE_CONTEXTMENU_EDIT,
    FullComposeEntrySourceType,
    FULL_COMPOSE_ENTRY_SOURCE_UNDO,
    QUICK_COMPOSE_ENTRY_SOURCE_SPACES_CALENDAR_ASSET,
} from 'owa-calendar-helpers-types/lib/ComposeMetricTypes';

/**
 * This function gets the new entry source for the compose form based on the previous entrySource
 * @param lastEntrySource the previous entrySource
 */
export function getUndoEntrySource(
    lastEntrySource: QuickComposeEntrySourceType | FullComposeEntrySourceType,
    formType: ComposeFormType
): QuickComposeEntrySourceType | FullComposeEntrySourceType {
    if (formType == QUICK_COMPOSE_FORM_TYPE) {
        switch (lastEntrySource) {
            case QUICK_COMPOSE_ENTRY_SOURCE_NEW_BUTTON:
            case QUICK_COMPOSE_ENTRY_SOURCE_UNDO_FROM_SURFACE:
            case QUICK_COMPOSE_ENTRY_SOURCE_UNDO_FROM_NEW_BUTTON:
                return QUICK_COMPOSE_ENTRY_SOURCE_UNDO_FROM_NEW_BUTTON;
            case QUICK_COMPOSE_ENTRY_SOURCE_SURFACE:
                return QUICK_COMPOSE_ENTRY_SOURCE_UNDO_FROM_SURFACE;
            case QUICK_COMPOSE_ENTRY_SOURCE_EDIT:
            case QUICK_COMPOSE_ENTRY_SOURCE_UNDO_FROM_EDIT:
            case QUICK_COMPOSE_ENTRY_SOURCE_PEEK_EDIT:
            case QUICK_COMPOSE_ENTRY_SOURCE_CONTEXTMENU_EDIT:
            case QUICK_COMPOSE_ENTRY_SOURCE_SPACES_CALENDAR_ASSET:
                return QUICK_COMPOSE_ENTRY_SOURCE_UNDO_FROM_EDIT;
            default:
                return null;
        }
    } else {
        return FULL_COMPOSE_ENTRY_SOURCE_UNDO;
    }
}
